import { render, staticRenderFns } from "./InputLicencePlate.vue?vue&type=template&id=4dceab8f&scoped=true&"
import script from "./InputLicencePlate.vue?vue&type=script&lang=ts&"
export * from "./InputLicencePlate.vue?vue&type=script&lang=ts&"
import style0 from "./InputLicencePlate.vue?vue&type=style&index=0&id=4dceab8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dceab8f",
  null
  
)

export default component.exports